import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import useSWR from "swr";
import { Box, Skeleton, TableContainer, Typography } from "@mui/material";
import { fetchData } from "../../../../lib/dashboard/data";
import NotFound from "../../../../components/notfound/NotFound";
import { COLORS } from "../../../../ui/Theme";

export default function IndustryRoiTable() {
    const { data = [], isLoading } = useSWR(
        "/dashboard/industry-roi",
        fetchData,
        {
            revalidateOnFocus: false,
            dedupingInterval: 60 * 1000,
        }
    );

    return (
        <Paper sx={{ height: 300 }}>
            {data.length < 1 ? (
                <Box sx={{ height: "100%" }}>
                    <NotFound />
                </Box>
            ) : (
                <>
                    <Typography sx={{ mb: 2, fontWeight: 700 }}>عملکرد صنعت </Typography>
                    <Tbl data={data} isLoading={isLoading} />
                </>
            )}
        </Paper>
    );
}

const Tbl = ({ data, isLoading }) => {
    const cols = Object.values({
        industrial_group_name: "گروه صنعتی",
        weekly_roi: "هفتگی",
        monthly_roi: "ماهانه",
        quarterly_roi: "سه ماهه",
        half_yearly_roi: "شش ماهه",
        yearly_roi: "سالانه",
        three_years_roi: "سه ساله",
    });

    return (
        <TableContainer sx={{ overflow: "auto", height: "100%" }}>
            <Table size="small" sx={{ tableLayout: "auto", whiteSpace: "nowrap" }}>
                <TableHead>
                    <TableRow>
                        {cols.map((col) => (
                            <TableCell
                                key={col}
                                sx={{
                                    fontWeight: 700,
                                    textAlign: "center",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {col}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {isLoading
                        ? [...Array(5)].map((_, index) => (
                            <TableRow key={index}>
                                {[...Array(7)].map((_, i) => (
                                    <TableCell
                                        key={i}
                                        sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                                    >
                                        <Skeleton variant="text" />
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))
                        : data.map((item, index) => (
                            <TableRow key={index} sx={{ direction: "rtl" }}>
                                <TableCell sx={{ textAlign: "center" }}>
                                    {item.industrial_group_name}
                                </TableCell>
                                <TableCell
                                    sx={{
                                        textAlign: "center",
                                        color: item.weekly_roi > 0 ? COLORS.GREEN : COLORS.RED,
                                    }}
                                >
                                    {item.weekly_roi}%
                                </TableCell>
                                <TableCell
                                    sx={{
                                        textAlign: "center",
                                        color: item.monthly_roi > 0 ? COLORS.GREEN : COLORS.RED,
                                    }}
                                >
                                    {item.monthly_roi}%
                                </TableCell>
                                <TableCell
                                    sx={{
                                        textAlign: "center",
                                        color: item.quarterly_roi > 0 ? COLORS.GREEN : COLORS.RED,
                                    }}
                                >
                                    {item.quarterly_roi}%
                                </TableCell>
                                <TableCell
                                    sx={{
                                        textAlign: "center",
                                        color:
                                            item.half_yearly_roi > 0 ? COLORS.GREEN : COLORS.RED,
                                    }}
                                >
                                    {item.half_yearly_roi}%
                                </TableCell>
                                <TableCell
                                    sx={{
                                        textAlign: "center",
                                        color: item.yearly_roi > 0 ? COLORS.GREEN : COLORS.RED,
                                    }}
                                >
                                    {item.yearly_roi}%
                                </TableCell>
                                <TableCell
                                    sx={{
                                        textAlign: "center",
                                        color:
                                            item.three_years_roi > 0 ? COLORS.GREEN : COLORS.RED,
                                    }}
                                >
                                    {item.three_years_roi}%
                                </TableCell>
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
